var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2404 3.90128C26.2608 3.90128 32.7859 9.12601 32.7859 15.5478C32.7859 22.6998 25.3037 27.1275 18.3713 27.1275C15.5539 27.1275 13.4492 26.55 11.9801 26.1907C10.5255 27.0824 9.66153 27.6991 5.76625 28.838C6.54443 26.8409 6.81643 24.8409 6.64043 22.6344C5.42298 21.1798 3.69498 19.1435 3.69498 15.5478C3.69498 9.12601 10.2201 3.90128 18.2404 3.90128ZM18.2404 0.992188C9.02153 0.992188 0.785889 7.1391 0.785889 15.5478C0.785889 18.5296 1.8608 21.4576 3.76334 23.7296C3.84334 26.3915 2.27534 30.2111 0.864434 32.9922C4.64916 32.3086 10.0295 30.7987 12.4688 29.3035C14.5299 29.8053 16.5037 30.0351 18.3728 30.0351C28.6768 30.0351 35.6964 22.9995 35.6964 15.5464C35.695 7.09401 27.4026 0.992188 18.2404 0.992188Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentBlue);
export default __webpack_public_path__ + "static/media/comment-blue.e17fe333c38cea8c3cb31e20e82cf21e.svg";
export { ForwardRef as ReactComponent };